import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Container, Grid, Paper, Tab, Tabs } from '@material-ui/core';
import utcToZonedTime from 'date-fns-tz/utcToZonedTime';
import ChartContainer from '../../components/ChartContainer';
import LineChart from '../../components/LineChart';
import TableChart from '../../components/TableChart';
import api from '../../services/api';
import { optionsStyle, chartWrapper } from './styles';
import { chartDataObject, tableChartDataObject } from '../../@types/chartData';
import OnModal from '../../components/Modal';
import { sortMonthYear } from './utils';
import Colors from '../../components/Colors';
import { getManagementsDates } from '../../actions/managementActions';
import ShowSnackbar, { SetSnackbarType } from '../../components/SnackBar';
import { endOfDay, startOfDay } from 'date-fns';
import { dateToBRT, dateToBRTDate } from '../../utils/formatDate';

interface RowTable {
  name: string;
  values: number[];
}
interface TableData {
  rows: RowTable[];
  legends: string[];
}
interface ResponseManagement {
  uuid: string;
  datetime_begin: string;
  datetime_end: string;
  datetime_map_begin: string;
  datetime_map_end: string;
}
const Dashboard: React.FC = () => {
  const stylesOption = optionsStyle();
  const styles = chartWrapper();
  const [activeValue, setActiveValue] = useState<number>(0);
  const [admin, setAdmin] = useState<boolean>(false);
  const [typist, setTypist] = useState<boolean>(false);
  const [tecEng, setTecEng] = useState<boolean>(false);
  const [geofi, setGeofi] = useState<boolean>(false);
  const [publicGroup, setPublicGroup] = useState<boolean>(false);

  useEffect(() => {
    const groups = localStorage.getItem('groups')?.split(' ');
    if (groups) {
      groups.forEach((gr: string) => {
        if (gr === 'public') {
          setPublicGroup(true);
        } else if (gr === 'digitador') {
          setTypist(true);
        } else if (gr === 'tec_engenharia') {
          setTecEng(true);
        } else if (gr === 'geofi') {
          setGeofi(true);
        } else if (gr === 'admin') {
          setAdmin(true);
        }
      });
    }
  }, []);

  const authHeader = useMemo(() => {
    return { Authorization: `Token ${localStorage.getItem('auth')}` };
  }, []);

  const defaultStartDate: Date = new Date(
    `${process.env.REACT_APP_MAP_START_DEFAULT_DATE}`,
  );
  const defaultEndDate: Date = new Date(`${process.env.REACT_APP_MAP_END_DEFAULT_DATE}`);

  const [acumulatedStarD, setacumulatedStartD] = useState<Date>(defaultStartDate);
  const [acumulatedEndD, setacumulatedEndD] = useState<Date>(defaultEndDate);
  const [acumulatedLoading, setacumulatedLoading] = useState<boolean>(false);

  const [projectionStarD, setProjectionStartD] = useState<Date>(defaultStartDate);
  const [projectionEndD, setProjectionEndD] = useState<Date>(defaultEndDate);
  const [projectionLoading, setProjectionLoading] = useState<boolean>(false);

  const [OMS1StarD, setOMS1StartD] = useState<Date>(defaultStartDate);
  const [OMS1EndD, setOMS1EndD] = useState<Date>(defaultEndDate);
  const [OMS1Loading, setOMS1Loading] = useState<boolean>(false);

  const [OMS2StarD, setOMS2StartD] = useState<Date>(defaultStartDate);
  const [OMS2EndD, setOMS2EndD] = useState<Date>(defaultEndDate);
  const [OMS2Loading, setOMS2Loading] = useState<boolean>(false);

  const [chartIncidentStarD, setChartIncidentStartD] = useState<Date>(defaultStartDate);
  const [chartIncidentEndD, setChartIncidentEndD] = useState<Date>(defaultEndDate);
  const [incidentLoading, setIncidentLoading] = useState<boolean>(false);

  const [chartMetaStarD, setChartMetaStartD] = useState<Date>(defaultStartDate);
  const [chartMetaEndD, setChartMetaEndD] = useState<Date>(defaultEndDate);
  const [chartMetaLoading, setChartMetaLoading] = useState<boolean>(false);

  const [veiculosFataisStarD, setVeiculosFataisStartD] = useState<Date>(defaultStartDate);
  const [veiculosFataisEndD, setVeiculosFataisEndD] = useState<Date>(defaultEndDate);
  const [veiculosFataisLoading, setVeiculosFataisLoading] = useState<boolean>(false);

  const [capaceteStartD, setCapaceteStartD] = useState<Date>(defaultStartDate);
  const [capaceteEndD, setCapaceteEndD] = useState<Date>(defaultEndDate);
  const [capaceteLoading, setCapaceteLoading] = useState<boolean>(false);
  const [chartCapacete, setChartCapacete] = useState<chartDataObject[]>([]);

  const [cinto1StartD, setCinto1StartD] = useState<Date>(defaultStartDate);
  const [cinto1EndD, setCinto1EndD] = useState<Date>(defaultEndDate);
  const [cintoLoading1, setCintoLoading1] = useState<boolean>(false);
  const [chartCinto1, setChartCinto1] = useState<chartDataObject[]>([]);

  const [cinto2StartD, setCinto2StartD] = useState<Date>(defaultStartDate);
  const [cinto2EndD, setCinto2EndD] = useState<Date>(defaultEndDate);
  const [cintoLoading2, setCintoLoading2] = useState<boolean>(false);
  const [chartCinto2, setChartCinto2] = useState<chartDataObject[]>([]);

  const [dispositivoRetencaoStartD, setDispositivoRetencaoStartD] = useState<Date>(
    defaultStartDate,
  );
  const [dispositivoRetencaoEndD, setDispositivoRetencaoEndD] = useState<Date>(
    defaultEndDate,
  );
  const [dispositivoRetencaoLoading, setDispositivoRetencaoLoading] = useState<boolean>(
    false,
  );
  const [dispositivoRetencao, setDispositivoRetencao] = useState<chartDataObject[]>([]);

  const [velocidadeStartD, setVelocidadeStartD] = useState<Date>(defaultStartDate);
  const [velocidadeEndD, setVelocidadeEndD] = useState<Date>(defaultEndDate);
  const [velocidadeLoading, setVelocidadeLoading] = useState<boolean>(false);
  const [velocidade, setVelocidade] = useState<chartDataObject[]>([]);

  const [alcoolStartD, setAlcoolStartD] = useState<Date>(defaultStartDate);
  const [alcoolEndD, setAlcoolEndD] = useState<Date>(defaultEndDate);
  const [alcoolLoading, setAlcoolLoading] = useState<boolean>(false);
  const [alcool, setAlcool] = useState<chartDataObject[]>([]);

  const [celularStartD, setCelularStartD] = useState<Date>(defaultStartDate);
  const [celularEndD, setCelularEndD] = useState<Date>(defaultEndDate);
  const [celularLoading, setCelularLoading] = useState<boolean>(false);
  const [celular, setCelular] = useState<chartDataObject[]>([]);

  const [chartAccumulated, setChartAccumulated] = useState<chartDataObject[]>([]);
  const [chartIncident, setChartIncident] = useState<chartDataObject[]>([]);
  const [chartProjection, setChartProjection] = useState<chartDataObject[]>([]);
  const [chartMeta, setChartMeta] = useState<chartDataObject[]>([]);
  const [chartOMS1, setChartOMS1] = useState<chartDataObject[]>([]);
  const [chartOMS2, setChartOMS2] = useState<chartDataObject[]>([]);

  const [loadingData, setLoadingData] = useState<boolean>(true);

  const [chartVeiculosFatais, setChartVeiculosFatais] = useState<tableChartDataObject[]>(
    [],
  );
  const [databegin, setdatabegin] = useState<string>('');
  const [dataend, setdataend] = useState<string>('');
  const [snackbar, setSnackbar] = useState<SetSnackbarType>({ open: false, message: '', });
  const tableData: TableData = {
    rows: chartVeiculosFatais,
    legends: [
      'Tipo de Veículo/Tipo de vítima',
      'Veículo Leve',
      'Motocicleta',
      'Veículo Pesado',
      'Ônibus',
      'Bicicleta',
      'Outros',
      'NI',
      'Totais',
    ],
  };
  const fetchDatas = useCallback(async () => {
    setLoadingData(true);
        try {
            const { data } = await getManagementsDates();
            const date_begin = data.datetime_begin;
            const date_end = data.datetime_end;
      
            setdatabegin(dateToBRT(new Date(data.datetime_begin), startOfDay));
            setdataend(dateToBRT(new Date(data.datetime_end), endOfDay));
            setacumulatedStartD(dateToBRTDate(new Date(data.datetime_begin), startOfDay));
            setacumulatedEndD(dateToBRTDate(new Date(data.datetime_end), endOfDay));
            setProjectionStartD(dateToBRTDate(new Date(data.datetime_begin), startOfDay));
            setProjectionEndD(dateToBRTDate(new Date(data.datetime_end), endOfDay));
            setChartMetaStartD(dateToBRTDate(new Date(data.datetime_begin), startOfDay));
            setChartMetaEndD(dateToBRTDate(new Date(data.datetime_end), endOfDay));
            setChartIncidentStartD(dateToBRTDate(new Date(data.datetime_begin), startOfDay));
            setChartIncidentEndD(dateToBRTDate(new Date(data.datetime_end), endOfDay));
            setVeiculosFataisStartD(dateToBRTDate(new Date(data.datetime_begin), startOfDay));
            setVeiculosFataisEndD(dateToBRTDate(new Date(data.datetime_end), endOfDay));
            setCapaceteStartD(dateToBRTDate(new Date(data.datetime_begin), startOfDay));
            setCapaceteEndD(dateToBRTDate(new Date(data.datetime_end), endOfDay));
            setCinto1StartD(dateToBRTDate(new Date(data.datetime_begin), startOfDay));
            setCinto1EndD(dateToBRTDate(new Date(data.datetime_end), endOfDay));
          } catch (error) {
            setSnackbar({ open: true, message: 'Erro ao estabelecer conexão. Tente novamente dentro de alguns instantes.' });
            
          } finally {
            setLoadingData(false);
          }
        }, [authHeader]);

  const fetchAccumulatedData = useCallback(async () => {
    setacumulatedLoading(true);
    api
      .get('/api/incident_records/chart_accumulated/', {
        headers: authHeader,
        params: {
          record_type: `${process.env.REACT_APP_INC_RECORD_TYPE}`,
          occurred_min: acumulatedStarD,
          occurred_max: acumulatedEndD,
        },
      })
      .then((chart) => {
        setChartAccumulated(chart.data);
        setacumulatedLoading(false);
      })
      .catch(() => {
        setacumulatedLoading(false);
      });
  }, [authHeader, acumulatedStarD, acumulatedEndD]);

  const fetchIncidentData = useCallback(async () => {
    setIncidentLoading(true);
    api
      .get('/api/incident_records/chart_incident/', {
        headers: authHeader,
        params: {
          record_type: `${process.env.REACT_APP_INC_RECORD_TYPE}`,
          occurred_min: chartIncidentStarD,
          occurred_max: chartIncidentEndD,
        },
      })
      .then((chart) => {
        setChartIncident(chart.data);
        console.log(chart.data);
        setIncidentLoading(false);
      })
      .catch(() => {
        setIncidentLoading(false);
      });
  }, [authHeader, chartIncidentStarD, chartIncidentEndD]);

  const fetchCapaceteData = useCallback(async () => {
    setProjectionLoading(true);
    api
      .get('/api/fatores_de_risco/uso_do_capacete/get_chart/', {
        headers: authHeader,
        params: {
          record_type: `${process.env.REACT_APP_INC_RECORD_TYPE}`,
          occurred_min: capaceteStartD,
          occurred_max: capaceteEndD,
        },
      })
      .then((chart) => {
        setChartCapacete(sortMonthYear(chart.data));
        setCapaceteLoading(false);
      })
      .catch(() => {
        setCapaceteLoading(false);
      });
  }, [authHeader, capaceteStartD, capaceteEndD]);

  const fetchCinto1Data = useCallback(async () => {
    setProjectionLoading(true);
    api
      .get('/api/fatores_de_risco/uso_do_cinto/get_chart/', {
        headers: authHeader,
        params: {
          record_type: `${process.env.REACT_APP_INC_RECORD_TYPE}`,
          occurred_min: cinto1StartD,
          occurred_max: cinto1EndD,
        },
      })
      .then((chart) => {
        setChartCinto1(sortMonthYear(chart.data));
        setCintoLoading1(false);
      })
      .catch(() => {
        setCintoLoading1(false);
      });
  }, [authHeader, cinto1StartD, cinto1EndD]);

  const fetchCinto2Data = useCallback(async () => {
    setProjectionLoading(true);
    api
      .get('/api/fatores_de_risco/uso_do_cinto2/get_chart/', {
        headers: authHeader,
        params: {
          record_type: `${process.env.REACT_APP_INC_RECORD_TYPE}`,
          occurred_min: cinto2StartD,
          occurred_max: cinto2EndD,
        },
      })
      .then((chart) => {
        setChartCinto2(sortMonthYear(chart.data));
        setCintoLoading2(false);
      })
      .catch(() => {
        setCintoLoading2(false);
      });
  }, [authHeader, cinto2StartD, cinto2EndD]);

  const fetchDispositivoRetencaoData = useCallback(async () => {
    setProjectionLoading(true);
    api
      .get('/api/fatores_de_risco/uso_disp_ret_criancas/get_chart/', {
        headers: authHeader,
        params: {
          record_type: `${process.env.REACT_APP_INC_RECORD_TYPE}`,
          occurred_min: dispositivoRetencaoStartD,
          occurred_max: dispositivoRetencaoEndD,
        },
      })
      .then((chart) => {
        setDispositivoRetencao(sortMonthYear(chart.data));
        setDispositivoRetencaoLoading(false);
      })
      .catch(() => {
        setDispositivoRetencaoLoading(false);
      });
  }, [authHeader, dispositivoRetencaoStartD, dispositivoRetencaoEndD]);

  const fetchVelocidadeData = useCallback(async () => {
    setProjectionLoading(true);
    api
      .get('/api/fatores_de_risco/velocidade/get_chart/', {
        headers: authHeader,
        params: {
          record_type: `${process.env.REACT_APP_INC_RECORD_TYPE}`,
          occurred_min: velocidadeStartD,
          occurred_max: velocidadeEndD,
        },
      })
      .then((chart) => {
        setVelocidade(sortMonthYear(chart.data));
        setVelocidadeLoading(false);
      })
      .catch(() => {
        setVelocidadeLoading(false);
      });
  }, [authHeader, velocidadeStartD, velocidadeEndD]);

  const fetchAlcoolData = useCallback(async () => {
    setProjectionLoading(true);
    api
      .get('/api/fatores_de_risco/dir_influencia_alcool/get_chart/', {
        headers: authHeader,
        params: {
          record_type: `${process.env.REACT_APP_INC_RECORD_TYPE}`,
          occurred_min: alcoolStartD,
          occurred_max: alcoolEndD,
        },
      })
      .then((chart) => {
        setAlcool(sortMonthYear(chart.data));
        setAlcoolLoading(false);
      })
      .catch(() => {
        setAlcoolLoading(false);
      });
  }, [authHeader, alcoolStartD, alcoolEndD]);

  const fetchCelularData = useCallback(async () => {
    setProjectionLoading(true);
    api
      .get('/api/fatores_de_risco/uso_do_celular/get_chart/', {
        headers: authHeader,
        params: {
          record_type: `${process.env.REACT_APP_INC_RECORD_TYPE}`,
          occurred_min: celularStartD,
          occurred_max: celularEndD,
        },
      })
      .then((chart) => {
        setCelular(sortMonthYear(chart.data));
        setCelularLoading(false);
      })
      .catch(() => {
        setCelularLoading(false);
      });
  }, [authHeader, celularStartD, celularEndD]);

  const fetchProjectionData = useCallback(async () => {
    setProjectionLoading(true);
    api
      .get('/api/incident_records/chart_projecao/', {
        headers: authHeader,
        params: {
          record_type: `${process.env.REACT_APP_INC_RECORD_TYPE}`,
          occurred_min: projectionStarD,
          occurred_max: projectionEndD,
        },
      })
      .then((chart) => {
        setChartProjection(chart.data);
        setProjectionLoading(false);
      })
      .catch(() => {
        setProjectionLoading(false);
      });
  }, [authHeader, projectionStarD, projectionEndD]);

  const fetchMetaData = useCallback(async () => {
    setChartMetaLoading(true);
    api
      .get('/api/incident_records/chart_meta/', {
        headers: authHeader,
        params: {
          occurred_min: new Date(`${chartMetaEndD.getFullYear()}-01-01T00:00:00Z`),
          occurred_max: new Date(`${chartMetaEndD.getFullYear()}-12-31T23:59:59Z`),
        },
      })
      .then((chart) => {
        setChartMeta(chart.data);
        setChartMetaLoading(false);
      })
      .catch(() => {
        setChartMetaLoading(false);
      });
  }, [authHeader, chartMetaEndD]);

  const fetchOMS1Data = useCallback(async () => {
    setOMS1Loading(true);
    api
      .get('/api/oms1/get_chart/', {
        headers: authHeader,
      })
      .then((chart) => {
        setChartOMS1(chart.data);
        setOMS1Loading(false);
      })
      .catch(() => {
        setOMS1Loading(false);
      });
  }, [authHeader]);

  const fetchOMS2Data = useCallback(async () => {
    setOMS2Loading(true);
    api
      .get('/api/oms2/get_chart/', {
        headers: authHeader,
      })
      .then((chart) => {
        setChartOMS2(chart.data);
        setOMS2Loading(false);
      })
      .catch(() => {
        setOMS2Loading(false);
      });
  }, [authHeader]);

  const fetchVeiculoasFatais = useCallback(async () => {
    setVeiculosFataisLoading(true);
    api
      .get('/api/incident_records/chart_veiculo_fatais/', {
        headers: authHeader,
        params: {
          record_type: `${process.env.REACT_APP_INC_RECORD_TYPE}`,
          occurred_min: veiculosFataisStarD,
          occurred_max: veiculosFataisEndD,
        },
      })
      .then((chart) => {
        setChartVeiculosFatais(chart.data);
        setVeiculosFataisLoading(false);
      })
      .catch(() => {
        setVeiculosFataisLoading(false);
      });
  }, [authHeader, veiculosFataisStarD, veiculosFataisEndD]);

  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setActiveValue(newValue);
  };

  useEffect(() => {
    fetchOMS1Data();
    fetchOMS2Data();
    fetchDatas();
  }, [fetchOMS1Data, fetchOMS2Data, fetchDatas]);

  useEffect(() => {
    if (!loadingData) {
      fetchIncidentData();
      fetchAccumulatedData();
      fetchVeiculoasFatais();
      fetchProjectionData();
      fetchMetaData();
      fetchCapaceteData();
      fetchCinto1Data();
      fetchCinto2Data();
      fetchDispositivoRetencaoData();
      fetchAlcoolData();
      fetchVelocidadeData();
      fetchCelularData();
    }
  }, [
    fetchProjectionData,
    fetchMetaData,
    fetchAccumulatedData,
    fetchIncidentData,
    fetchVeiculoasFatais,
    loadingData,
    fetchCapaceteData,
    fetchCinto1Data,
    fetchCinto2Data,
    fetchDispositivoRetencaoData,
    fetchAlcoolData,
    fetchVelocidadeData,
    fetchCelularData,
  ]);

  return (
    <>
      <Container className={styles.root} maxWidth={false}>
        <Container className={stylesOption.root} maxWidth={false}>
          <Paper square className={stylesOption.tabPaper}>
            <Tabs
              value={activeValue}
              onChange={handleTabChange}
              variant="fullWidth"
              TabIndicatorProps={{ style: { backgroundColor: Colors.main, height: 4 } }}
            >
              <Tab label="Indicadores de Segurança Viária" />
              <Tab label="Fatores de Risco" />
              {/* <Tab label="Painel 3" /> */}
            </Tabs>
          </Paper>
        </Container>
        <Grid container>
          {/* {activeValue === 0 && (
            <>
              <Container className={styles.flex} maxWidth={false}>
                {publicGroup && (!tecEng || !admin || !typist || !geofi) ? (
                  <ChartContainer
                    titleChart="Acompanhamento mensal das mortes no trânsito"
                    yearPicker
                    setStartDate={setChartMetaStartD}
                    setEndDate={setChartMetaEndD}
                    loading={chartMetaLoading}
                    datetime_begin={databegin}
                    datetime_end={dataend}
                  >
                    <OnModal>
                      <LineChart
                        legendY="Nº de Vítimas Fatais"
                        data={chartMeta}
                        legendOne="Número acumulado"
                        lineTwo={false}
                      />
                    </OnModal>
                  </ChartContainer>
                ) : (
                  <ChartContainer
                    titleChart="Acompanhamento mensal das mortes no trânsito"
                    yearPicker
                    setStartDate={setChartMetaStartD}
                    setEndDate={setChartMetaEndD}
                    loading={chartMetaLoading}
                    datetime_begin={databegin}
                    datetime_end={dataend}
                  >
                    <OnModal>
                      <LineChart
                        legendY="Nº de Vítimas Fatais"
                        data={chartMeta}
                        legendOne="Número acumulado"
                        legendTwo="Meta"
                        lineTwo
                      />
                    </OnModal>
                  </ChartContainer>
                )}

                <ChartContainer
                  titleChart="Quantidade acumulada de mortes por mês"
                  yearsPicker
                  setStartDate={setProjectionStartD}
                  setEndDate={setProjectionEndD}
                  loading={projectionLoading}
                  datetime_begin={databegin}
                  datetime_end={dataend}
                >
                  <OnModal>
                    <LineChart
                      legendY="Nº de Vítimas Fatais"
                      legendOne={`${projectionStarD.getUTCFullYear()}`}
                      legendTwo={`${projectionEndD.getUTCFullYear()}`}
                      data={chartProjection}
                      lineTwo
                    />
                  </OnModal>
                </ChartContainer>
              </Container>
              <Container className={styles.flex} maxWidth={false}>
                {publicGroup && !(geofi || typist || admin || tecEng) ? (
                  <ChartContainer
                    titleChart="Histórico e projeção para o número de mortes por ano"
                    setStartDate={setacumulatedStartD}
                    setEndDate={setacumulatedEndD}
                    loading={acumulatedLoading}
                  >
                    <OnModal>
                      <LineChart
                        legendY="Nº de Vítimas Fatais"
                        data={chartAccumulated}
                        legendOne="Total"
                        lineTwo={false}
                      />
                    </OnModal>
                  </ChartContainer>
                ) : (
                  <ChartContainer
                    titleChart="Histórico e projeção para o número de mortes por ano"
                    setStartDate={setacumulatedStartD}
                    setEndDate={setacumulatedEndD}
                    loading={acumulatedLoading}
                  >
                    <OnModal>
                      <LineChart
                        legendY="Nº de Vítimas Fatais"
                        data={chartAccumulated}
                        legendOne="Total"
                        legendTwo="Projeção"
                        projection
                        lineTwo
                      />
                    </OnModal>
                  </ChartContainer>
                )}
                <ChartContainer
                  titleChart="Evolução da mortalidade por período definido"
                  datePicker
                  datetime_begin={databegin}
                  datetime_end={dataend}
                  setStartDate={setChartIncidentStartD}
                  setEndDate={setChartIncidentEndD}
                  loading={incidentLoading}
                >
                  <OnModal>
                    <LineChart
                      legendY="Nº de Vítimas Fatais"
                      legendOne={`${chartIncidentStarD.getUTCFullYear()}`}
                      legendTwo={`${chartIncidentEndD.getUTCFullYear()}`}
                      data={chartIncident}
                      lineTwo
                    />
                  </OnModal>
                </ChartContainer>
              </Container>
            </>
          )} */}
          {activeValue === 0 && (
            <>
              <Container className={styles.flex} maxWidth={false}>
                <ChartContainer
                  titleChart="Evolução das mortes no trânsito em relação à frota "
                  setStartDate={setOMS1StartD}
                  setEndDate={setOMS1EndD}
                  loading={OMS1Loading}
                >
                  <OnModal>
                    <LineChart
                      legendY="Mortos/10K veículos"
                      legendOne="Mortos/10K veículos"
                      legendTwo="Mortos/10K motocicletas"
                      data={chartOMS1}
                      OMS
                      lineTwo
                    />
                  </OnModal>
                </ChartContainer>
                <ChartContainer
                  titleChart="Evolução da taxa de mortalidade no trânsito"
                  setStartDate={setOMS2StartD}
                  setEndDate={setOMS2EndD}
                  loading={OMS2Loading}
                >
                  <OnModal>
                    <LineChart
                      legendY="Mortos/100K de habitantes"
                      legendOne="Mortos/100k habitantes"
                      legendTwo=" "
                      data={chartOMS2}
                      OMS
                      lineTwo={false}
                    />
                  </OnModal>
                </ChartContainer>
              </Container>
              <Container className={styles.flex} maxWidth={false}>
                <ChartContainer
                  titleChart="Matriz de incidência entre vítimas e veículos"
                  loading={veiculosFataisLoading}
                  yearsPicker
                  datetime_begin={databegin}
                  datetime_end={dataend}
                  setStartDate={setVeiculosFataisStartD}
                  setEndDate={setVeiculosFataisEndD}
                >
                  <TableChart data={tableData} />
                </ChartContainer>
              </Container>
            </>
          )}

          {activeValue === 1 && (
            <>
              <Container className={styles.flex} maxWidth={false}>
                <ChartContainer
                  titleChart="Uso do capacete"
                  loading={capaceteLoading}
                  // yearsPicker
                  datetime_begin={databegin}
                  datetime_end={dataend}
                  setStartDate={setCapaceteStartD}
                  setEndDate={setCapaceteEndD}
                >
                  <LineChart
                    legendY="Ocupantes usando capacete (%)"
                    data={chartCapacete}
                    legendOne="Todos os ocupantes usando capacete"
                    legendTwo="Todos os ocupantes usando corretamente o capacete"
                    projection
                    lineTwo
                  />
                </ChartContainer>
                <ChartContainer
                  titleChart="Uso do cinto"
                  loading={cintoLoading1}
                  // yearsPicker
                  datetime_begin={databegin}
                  datetime_end={dataend}
                  setStartDate={setCinto1StartD}
                  setEndDate={setCinto1EndD}
                >
                  <LineChart
                    legendY="Passageiros/condutores usando cinto de segurança (%)"
                    data={chartCinto1}
                    legendOne="Todos os ocupantes"
                    legendTwo="Condutores"
                    projection
                    lineTwo
                  />
                </ChartContainer>
              </Container>
              <Container className={styles.flex} maxWidth={false}>
                <ChartContainer
                  titleChart="Uso do cinto - Passageiros"
                  loading={cintoLoading2}
                  // yearsPicker
                  datetime_begin={databegin}
                  datetime_end={dataend}
                  setStartDate={setCinto2StartD}
                  setEndDate={setCinto2EndD}
                >
                  <LineChart
                    legendY="Passageiros utilizando o cinto de segurança (%)"
                    data={chartCinto2}
                    legendOne="Passageiros no banco dianteiro"
                    legendTwo="Passageiros no banco traseiro"
                    projection
                    lineTwo
                  />
                </ChartContainer>

                <ChartContainer
                  titleChart="Uso do dispositivo de retenção para crianças"
                  loading={dispositivoRetencaoLoading}
                  // yearsPicker
                  datetime_begin={databegin}
                  datetime_end={dataend}
                  setStartDate={setDispositivoRetencaoStartD}
                  setEndDate={setDispositivoRetencaoEndD}
                >
                  <LineChart
                    legendY="Crianças ou bebês utilizando dispositivo de segurança (%)"
                    data={dispositivoRetencao}
                    legendOne="Passageiros (crianças) utilizando alguma medida de segurança"
                    legendTwo="Passageiros (bebês) utilizando alguma medida de segurança"
                    projection
                    lineTwo
                  />
                </ChartContainer>
              </Container>

              <Container className={styles.flex} maxWidth={false}>
                <ChartContainer
                  titleChart="Velocidade"
                  loading={velocidadeLoading}
                  // yearsPicker
                  datetime_begin={databegin}
                  datetime_end={dataend}
                  setStartDate={setVelocidadeStartD}
                  setEndDate={setVelocidadeEndD}
                >
                  <LineChart
                    legendY="Veículos que excedem o limite de velocidade (%)"
                    data={velocidade}
                    legendOne="Condutores no geral excedendo velocidade"
                    legendTwo="Motociclistas"
                    projection
                    lineTwo
                  />
                </ChartContainer>

                <ChartContainer
                  titleChart="Direção sob influência do álcool"
                  loading={alcoolLoading}
                  // yearsPicker
                  datetime_begin={databegin}
                  datetime_end={dataend}
                  setStartDate={setAlcoolStartD}
                  setEndDate={setAlcoolEndD}
                >
                  <LineChart
                    legendY="Condutores infringido a Lei Seca (%)"
                    data={alcool}
                    legendOne="Positivos + Recusas/Total de motoristas parados"
                    legendTwo="Positivos/Total de motoristas parados"
                    projection
                    lineTwo
                  />
                </ChartContainer>
              </Container>

              <Container className={styles.flex} maxWidth={false}>
                <ChartContainer
                  titleChart="Uso do celular ao voltante"
                  loading={celularLoading}
                  // yearsPicker
                  datetime_begin={databegin}
                  datetime_end={dataend}
                  setStartDate={setCelularStartD}
                  setEndDate={setCelularEndD}
                >
                  <LineChart
                    legendY="Condutores utilizando o celular ao volante (%)"
                    data={celular}
                    legendOne="Digitando"
                    legendTwo="Falando"
                    projection
                    lineTwo
                  />
                </ChartContainer>
              </Container>
            </>
          )}
        </Grid>
      </Container>
    </>
  );
};

export default Dashboard;
